import * as React from "react";
import { Clock } from "react-feather";
import { Alert, Modal, notification } from "antd";
import humanizeDuration from "humanize-duration";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";

export interface UninstallLocationData {
  command: string;
  manifestLink: string;
  expires: number;
}

interface Props {
  uninstallLocationData: UninstallLocationData;
  onCancel: () => void;
}

export const UninstallLocation: React.FC<Props> = ({ uninstallLocationData, onCancel }) => {
  const [timeLeft, setTimeLeft] = React.useState<number>(uninstallLocationData.expires - Math.floor(Date.now() / 1000));
  const [isExpired, setIsExpired] = React.useState<boolean>(false);

  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000);
      const timeDifference = uninstallLocationData.expires - currentTime;
      if (timeDifference <= 0) {
        setIsExpired(true);
        clearInterval(interval);
      }
      setTimeLeft(timeDifference);
    }, 1000);

    return () => clearInterval(interval);
  }, [uninstallLocationData.expires]);

  function copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    notification.success({
      message: "Copied to clipboard",
    });
  }

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          Uninstall Location
          <Alert
            type="error"
            icon={<Clock size={16} />}
            description={
              <span>{isExpired ? "Expired" : `Expires In: ${humanizeDuration(timeLeft * 1000, { round: true })}`}</span>
            }
          />
        </div>
      }
      open={true}
      maskClosable={false}
      onCancel={() => onCancel()}
      onOk={() => onCancel()}
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <span className="list-decimal">Apply below command in kubectl</span>
          <div className="flex items-center">
            <input
              className="flex-grow border px-4 py-2"
              style={{
                width: 450,
              }}
              disabled={true}
              value={uninstallLocationData.command}
            />
            <CopyButtonWithApproval className="ml-1" value={uninstallLocationData.command} />
          </div>
        </div>
        <Alert
          type="warning"
          description={
            <span>Manifest link in the command contains sensitive information and is only available temporarily.</span>
          }
        />
      </div>
    </Modal>
  );
};
